var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadStripe2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 879.341,
    height: 152.409,
    viewBox: "0 0 879.341 152.409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M879.341 152.409L874.412 152.21L876.887 146.763L879.341 152.409ZM342.933 12.4902L574.037 140.076L513.526 137.631L282.057 9.84277L342.933 12.4902ZM456.141 17.4121L614.445 104.808V135.762L395.276 14.7656L456.141 17.4121ZM229.712 7.56738L461.498 135.53L401 133.086L168.85 4.92188L229.712 7.56738ZM116.505 2.64648L348.972 130.985L288.459 128.54L55.625 0L116.505 2.64648ZM236.43 126.439L175.921 123.994L14.2627 34.748L19.167 6.49414L236.43 126.439ZM123.893 121.894L63.3906 119.449L5.13965 87.29L10.0439 59.041L123.893 121.894ZM11.3623 117.348L0 116.89L0.921875 111.584L11.3623 117.348ZM567.186 22.2412L614.445 48.332V78.1855L508.485 19.6885L567.186 22.2412Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadStripe2);
export default __webpack_public_path__ + "static/media/road-stripe-2.5b3a51f08d33051fc76b2d9d9092143e.svg";
export { ForwardRef as ReactComponent };